import { render } from "./InputTransaction.vue?vue&type=template&id=27120f06&scoped=true"
import script from "./InputTransaction.vue?vue&type=script&lang=js"
export * from "./InputTransaction.vue?vue&type=script&lang=js"

import "./InputTransaction.vue?vue&type=style&index=0&id=27120f06&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27120f06"]])

export default __exports__